<template>
    <div>
        <base-crud
                crudName="Categorias de Receitas"
                newText="Nova Categoria"
                :table="categoryRecipeTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="false"
                :enableEdit="true"
                :enableDelete="false"
                :enableView="false"
                :enableSetStatus="true"
        >
        </base-crud>

    </div>
</template>

<script>

    import BaseCrud from '../Base/BaseCrud'

    export default {

        data: function () {
            return {
                categoryRecipeTable: 'categoryRecipeTable',
                users: [],
                pages: [],
                url: '',
                columns: ['id', 'category_recipe_id', 'description', 'status', 'photo', 'actions'],
                tableData: [],
                options: {
                    sortable: ['id', 'category_recipe_id', 'description', 'status'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll'},
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        'category_recipe_id': 'Categoria da Receita',
                        'description': 'Descrição',
                        'photo': 'Foto',
                        'actions': 'Ações'
                    },
                    templates: {
                        status: function (h, row, index) {
                            return row.status === 2 ? 'Inativo' : 'Ativo'
                        }
                    }
                },
                endPoint: 'categoryRecipe/'
            }
        },
        components: {
            BaseCrud
        }

    }
</script>

<style>

    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/CategoryRecipe/Crud.vue